"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PickerContainer = _interopRequireDefault(require("../pickerContainer/PickerContainer"));

var _PickerColor = _interopRequireDefault(require("../pickerColor/PickerColor"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ** The selector shows users the options they have to choose from different type of content. It has a selected and deselected status. **
 *
 * There are 3 text options: PrimaryText, SecondaryText, FooterText
 *
 * There is a build in color option.
 *
 * There is 1 state: selected
 */
var PickerStandard = function PickerStandard(_ref) {
  var title = _ref.title,
      footerNote = _ref.footerNote,
      selected = _ref.selected,
      disabled = _ref.disabled,
      color = _ref.color,
      _action = _ref.action;
  return /*#__PURE__*/_react.default.createElement(_PickerContainer.default, {
    action: function action() {
      return _action();
    },
    selected: selected,
    disabled: disabled
  }, color && /*#__PURE__*/_react.default.createElement(_PickerColor.default, {
    color: color,
    action: function action() {}
  }), title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: title,
    variant: color ? "bodySmall" : "body",
    color: disabled ? "MidGrey" : "VfGrey",
    bold: selected
  }), footerNote && !color && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: footerNote,
    variant: "bodySmall",
    color: disabled ? "MidGrey" : "Anthracite"
  }));
};

PickerStandard.propTypes = {
  /** The color prop exposed from color picker */
  color: _propTypes.default.string,

  /** The primary text of the picker */
  title: _propTypes.default.string,

  /** The secondary text of the picker */
  footerNote: _propTypes.default.string,

  /** The selected state of the picker */
  selected: _propTypes.default.bool,

  /** The disabled state of the picker */
  disabled: _propTypes.default.bool,

  /** Action to call when click the picker */
  action: _propTypes.default.func.isRequired
};
PickerStandard.defaultProps = {
  color: null,
  title: null,
  footerNote: null,
  selected: false,
  disabled: false
};
var _default = PickerStandard;
exports.default = _default;